import { UserEntity } from 'entities/User.entity';

export const userInfo: UserEntity = {
  driverName: '田中太郎',
  truckName: '柏井1672',
  currentDate: '2023-04-02',
  status: '勤務中'
};
